import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { api, setToken } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.access_token);
      toast.success("Welcome back, Owen.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-white/5 border border-white/10 text-white placeholder:text-slate-500 px-4 py-3 text-sm focus:outline-none focus:border-[#C9A876] focus:ring-1 focus:ring-[#C9A876] transition-colors";

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-[#0E2750] px-6 py-20"
    >
      <div className="absolute top-6 left-6">
        <Link
          to="/"
          data-testid="back-to-site"
          className="text-xs uppercase tracking-[0.25em] text-slate-500 hover:text-[#C9A876]"
        >
          ← Back to site
        </Link>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md border border-white/10 bg-[#15315F]/70 p-8 md:p-10"
      >
        <Lock size={24} strokeWidth={1.25} className="text-[#C9A876] mb-6" />
        <span className="font-mono-eyebrow text-[#C9A876]">◆ Arcpoint Admin</span>
        <h1 className="mt-3 font-display text-3xl tracking-tight text-white mb-8">
          Sign in
        </h1>
        <form onSubmit={submit} className="space-y-5">
          <label className="block">
            <span className="font-mono-eyebrow text-slate-400 mb-2 block">Email</span>
            <input
              data-testid="admin-email-input"
              required
              type="email"
              className={inputCls}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label className="block">
            <span className="font-mono-eyebrow text-slate-400 mb-2 block">Password</span>
            <input
              data-testid="admin-password-input"
              required
              type="password"
              className={inputCls}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <button
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 px-6 py-4 bg-[#C9A876] hover:bg-[#DCC298] disabled:opacity-60 text-black text-sm font-semibold tracking-wide transition-colors duration-300"
          >
            {loading && <Loader2 size={16} className="animate-spin" />}
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </motion.div>
    </main>
  );
}
